import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Tooltip,
} from "@material-ui/core";

import api from "../../services/api";
import toastError from "../../errors/toastError";
import { i18n } from "../../translate/i18n";

// Unicode escapes keep the emojis intact even when Windows, Git and Docker
// use different text encodings while rebuilding the frontend.
const REACTIONS = [
  "\uD83D\uDC4D", // thumbs up
  "\u2764\uFE0F", // heart
  "\uD83D\uDE02", // tears of joy
  "\uD83D\uDE2E", // surprised
  "\uD83D\uDE22", // sad
  "\uD83D\uDE4F", // folded hands
];

const ReactionPickerModal = ({ open, onClose, message, ticketId }) => {
  const [loading, setLoading] = useState(false);

  const handleReaction = async emoji => {
    if (!message?.id || !ticketId) return;

    setLoading(true);
    try {
      await api.post(
        `/messages/${encodeURIComponent(message.id)}/reaction`,
        { emoji, ticketId }
      );
      onClose();
    } catch (err) {
      toastError(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={loading ? undefined : onClose} maxWidth="xs" fullWidth>
      <DialogTitle>{i18n.t("messageReaction.title")}</DialogTitle>
      <DialogContent dividers style={{ display: "flex", justifyContent: "space-around" }}>
        {REACTIONS.map(emoji => (
          <Tooltip key={emoji} title={emoji}>
            <span>
              <IconButton
                onClick={() => handleReaction(emoji)}
                disabled={loading}
                style={{ fontSize: 28 }}
              >
                {emoji}
              </IconButton>
            </span>
          </Tooltip>
        ))}
      </DialogContent>
      <DialogActions>
        <Button onClick={() => handleReaction("")} disabled={loading} color="secondary">
          {i18n.t("messageReaction.remove")}
        </Button>
        <Button onClick={onClose} disabled={loading}>
          {i18n.t("messageReaction.cancel")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ReactionPickerModal;
